export const _setRecordEpdCntID = (state, action) => {
  state.recordEpdCntID = action.payload;
};

export const _setStartDate = (state, action) => {
  state.startDate = action.payload;
};

export const _setEndDate = (state, action) => {
  state.endDate = action.payload;
};

export const _setRoleType = (state, action) => {
  state.roleType = action.payload;
};

export const _setCaseManagerOrParoleAgent = (state, action) => {
  state.caseManagerOrParoleAgent = action.payload;
};
